import { Directive, ElementRef, Input, OnChanges, SimpleChanges, Renderer2 } from '@angular/core';
import { CmsImage, ImageResizerModifiers } from '../_models/connect/cms';
import { environment } from '../../../environments/environment';

@Directive({
  selector: '[appStrapiImageSharp]',
})
export class StrapiImageSharpDirective implements OnChanges {
  private cmsServiceUrl = environment.cmsServiceUrl;

  // Input image
  @Input() imageSrc: CmsImage = null;

  // Input for the query string modifiers (e.g., { width: 300, quality: 80 })
  @Input() modifiers: ImageResizerModifiers = {};

  constructor(
    private el: ElementRef,
    private renderer: Renderer2
  ) {}

  ngOnChanges(changes: SimpleChanges): void {
    if (changes.imageSrc || changes.modifiers) {
      this.updateImageSrc();
    }
  }

  private updateImageSrc(): void {
    if (!this.imageSrc) {
      return;
    }

    // Build query string from modifiers
    const queryParams = this.buildQueryParams(this.modifiers);

    // Append query string to imageSrc
    const updatedSrc = queryParams
      ? (`${this.cmsServiceUrl}/api/image-processor/${this.imageSrc.hash}${this.imageSrc.ext}?${queryParams}` as string)
      : (this.imageSrc.url as string);

    // Update the `src` attribute of the image
    this.renderer.setAttribute(this.el.nativeElement, 'src', updatedSrc as string);
  }

  private buildQueryParams(modifiers: { [key: string]: any }): string {
    return Object.keys(modifiers)
      .map((key) => `${encodeURIComponent(key)}=${encodeURIComponent(modifiers[key])}`)
      .join('&');
  }
}
